<template>
    <div>

        <v-container>
            <v-row >
                <v-col cols="12" align="center">
                    <h2>Основные метрики на одной странице</h2>
                </v-col>
                <v-col cols="12" align="center">
                    <h3>Статистика за сегодня {{dateNow}}</h3>
                </v-col>
                <v-col cols="12">
                    <v-card>
                        <v-card-title>
                            Отправлено: {{ messagesToday.output }}
                        </v-card-title>
                        <v-card-title>
                            Принято: {{ messagesToday.input }}
                        </v-card-title>
                        <v-card-title>
                            Рассылки: {{ messagesToday.mailing }}
                        </v-card-title>
                        <v-card-title>
                            Подписались: {{ clientsToday.subscribe }}
                        </v-card-title>
                        <v-card-title>
                            Отписались: {{ clientsToday.unsubscribe }}
                        </v-card-title>
                    </v-card>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" align="center">
                    <h3>Исторические события</h3>
                </v-col>
                <v-col cols="12" sm="6" xs="12" md="6">
                    <v-card>
                        <v-card-title>Сообщения</v-card-title>
                        <v-card-text>
                            <line-chart
                                    :chart-data="dataMessagesOutput"
                                    :options="options"
                            ></line-chart>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn @click="updateCountDaysMessages(7)">Отчет за 7 дней</v-btn>
                            <v-btn @click="updateCountDaysMessages(14)">Отчет за 14 дней</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="6" xs="12" md="6">
                    <v-card>
                        <v-card-title>Подписчики</v-card-title>
                        <v-card-text>
                            <line-chart
                                    :chart-data="dataClients"
                                    :options="options"

                            ></line-chart>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn @click="updateCountDaysClients(7)">Отчет за 7 дней</v-btn>
                            <v-btn @click="updateCountDaysClients(14)">Отчет за 14 дней</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LineChart from './LineChart'
import timeHelpers from '../../../scripts/helpers/timeHelpers'
export default {
    name: 'Report',
    components: {
        LineChart
    },
    data: () => ({
        dataMessagesOutput: [],
        dataClients: [],
        options: {
            legend: {
                display: true,
                position: 'top'
            },
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                yAxes: [{
                    display: true,
                    ticks: {
                        beginAtZero: false,
                        min: 0
                    }
                }],
                xAxes: [{
                    display: true,
                    ticks: {
                        beginAtZero: false
                    }
                }]
            },
            chartArea: {
                backgroundColor: '#bacff8'
            }
        }
    }),
    methods: {
        ...timeHelpers,
        fillData(data) {
            let newData = Object.assign({}, { labels: this.messagesSendInfoLabels,
                datasets: [
                ] })
            let datasetTemplate = {
                label: 'Входящие сообщения',
                data: [],
                fill: true,
                borderWidth: 3,
                pointStyle: ''
                // borderColor: '#f8413f'
            }
            data.forEach(function(dataset, i, array) {
                newData.datasets.push(Object.assign({}, datasetTemplate, dataset))
            })
            return newData
        },
        fillDataClients(data) {
            let newData = Object.assign({}, { labels: this.clientsInfoLabels,
                datasets: [
                ] })
            let datasetTemplate = {
                label: 'Входящие сообщения',
                data: [],
                borderWidth: 3,
                pointStyle: '',
                fill: true,
                borderColor: '#f8413f'
            }
            data.forEach(function(dataset) {
                newData.datasets.push(Object.assign({}, datasetTemplate, dataset))
            })
            return newData
        },
        fillEmpty() {
            let date = new Date()
            let labels = []
            let values = []
            for (let i = 0; i <= 7; i++) {
                labels.push(this.zero(date.getDate() + i - 1) + '.' + this.zero((date.getMonth() + 1)) + '.' + date.getFullYear())
                values.push(0)
            }
            this.dataMessagesOutput = {
                labels: labels,
                datasets: [
                    {
                        label: 'Отправленные',
                        backgroundColor: '#bacff8',
                        data: values,
                        fill: true,
                        borderWidth: 3,
                        pointStyle: '',
                        borderColor: '#2582f8'
                    },
                    {
                        label: 'Входящие',
                        backgroundColor: '#f8cdc8',
                        data: values,
                        fill: true,
                        borderWidth: 3,
                        pointStyle: '',
                        borderColor: '#f85550'
                    }
                ]
            }
            this.dataClients = {
                labels: labels,
                datasets: [
                    {
                        label: 'Подписались',
                        backgroundColor: '#bacff8',
                        data: values,
                        fill: true,
                        borderWidth: 3,
                        pointStyle: '',
                        borderColor: '#2582f8'
                    },
                    {
                        label: 'Отписались',
                        backgroundColor: '#f8cdc8',
                        data: values,
                        fill: true,
                        borderWidth: 3,
                        pointStyle: '',
                        borderColor: '#f85550'
                    }
                ]
            }
        },
        updateCountDaysMessages(countDays) {
            this.$store.dispatch('stats/loadMessages', { botId: this.$route.params.pathMatch, countDays: countDays })
            // this.$store.dispatch('stats/setValueLoadedMessagesOutput', false)
            // this.$store.dispatch('stats/setValueLoadedMessagesInput', false)
            // this.$store.dispatch('stats/loadMessageSendInfoOutput', { botId: this.$route.params.pathMatch, countDays: countDays })
            // this.$store.dispatch('stats/loadMessageSendInfoInput', { botId: this.$route.params.pathMatch, countDays: countDays })
        },
        updateCountDaysClients(countDays) {
            this.$store.dispatch('stats/loadClientsSubscribeInfo', { botId: this.$route.params.pathMatch, countDays: countDays })
            this.$store.dispatch('stats/loadClientsUnsubscribeInfo', { botId: this.$route.params.pathMatch, countDays: countDays })
        }
    },
    computed: {
        dateNow() {
            return this.getDateFormatOutDate(new Date(), 'DD.MM.YYYY')
        },
        ...mapGetters({
            messagesSendInfoOutput: 'stats/messagesSendInfoOutput',
            messagesSendInfoInput: 'stats/messagesSendInfoInput',
            messagesSendInfoMailing: 'stats/messagesSendInfoMailing',
            messagesSendInfoLabels: 'stats/messagesSendInfoLabels',
            getClientsInfoSubscribe: 'stats/getClientsInfoSubscribe',
            getClientsInfoUnsubscribe: 'stats/getClientsInfoUnsubscribe',
            loadedMessagesOutput: 'stats/loadedMessagesOutput',
            loadedMessagesInput: 'stats/loadedMessagesInput',
            loadedClientsSubscribe: 'stats/loadedClientsSubscribe',
            loadedClientsUnsubscribe: 'stats/loadedClientsUnsubscribe',
            clientsInfoLabels: 'stats/getClientsInfoLabels',
            messagesToday: 'stats/messagesToday',
            clientsToday: 'stats/clientsToday'
        }),
        loadedMessages() {
            return this.loadedMessagesOutput && this.loadedMessagesInput
        },
        loadedClients() {
            return this.loadedClientsSubscribe && this.loadedClientsUnsubscribe
        }
    },
    watch: {
        loadedMessages(value) {
            if (value) {
                this.dataMessagesOutput = this.fillData([
                    {
                        label: 'Отправленные',
                        data: this.messagesSendInfoOutput,
                        backgroundColor: '#bacff8',
                        borderColor: '#2582f8'
                    },
                    {
                        label: 'Входящие',
                        data: this.messagesSendInfoInput,
                        backgroundColor: '#f8cdc8',
                        borderColor: '#f85550'
                    }
                ])
            }
            // this.fillData()
        },
        loadedMessagesMailing() {
            // this.fillData()
        },
        loadedClients(value) {
            if (value) {
                this.dataClients = this.fillDataClients([
                    {
                        label: 'Подписанные',
                        data: this.getClientsInfoSubscribe,
                        backgroundColor: '#bacff8',
                        borderColor: '#2582f8'
                    },
                    {
                        label: 'Отписанные',
                        data: this.getClientsInfoUnsubscribe,
                        backgroundColor: '#f8cdc8',
                        borderColor: '#f85550'
                    }
                ])
            }
        }
    },
    created() {
        this.fillEmpty()
        this.updateCountDaysMessages(7)
        this.updateCountDaysClients(7)
        this.$store.dispatch('stats/loadMessageSendInfoMailing', { botId: this.$route.params.pathMatch, countDays: 7 })
    }
}
</script>

<style scoped>

</style>
